import i18n from '@fiverr/i18n/singleton';
import { logger } from '@fiverr-private/obs';
import pathfinder from '@fiverr-private/pathfinder';
import type { EagerJobsTbdSdk } from '@fiverr-private/jtbd_sdk';
import { ROLLOUTS } from '@fiverr-private/homepage_common_types';
import { fetchActiveProject } from '../services/server/fetchActiveProject';
import { reportCardClick } from '../utils/reportCardClick';
import { getRelevantService } from '../utils/getRelevantService';
import { ICON_URL } from './constants';

export const BookPublishingProjectCardImpl = {
    condition: {
        rolloutName: ROLLOUTS.CHEETAHS_BOOK_PUBLISHING,
    },
    getJobInfo: async ({ externalServicesInfo, context }) => {
        try {
            const project = await fetchActiveProject(externalServicesInfo.extended_verticals_pegasus.url);

            if (!project) {
                return {
                    shouldDisplayJob: false,
                };
            }

            const relevantService = getRelevantService(project);

            const service = i18n.t(`jobs_tbd.book_publishing_project.services.${relevantService}`, {
                $scope: context.locale,
            });

            return {
                shouldDisplayJob: true,
                dismissInfo: { isDismissible: false },
                headerText: String(
                    i18n.t('jobs_tbd.book_publishing_project.header_text', { $scope: context.locale })
                ).toUpperCase(),
                jobPages: [
                    {
                        title: i18n.t('jobs_tbd.book_publishing_project.title', { $scope: context.locale }),
                        subtitle: i18n.t('jobs_tbd.book_publishing_project.subtitle', {
                            $scope: context.locale,
                            service,
                        }),
                        ctaText: i18n.t('jobs_tbd.book_publishing_project.cta', { $scope: context.locale }),
                        iconUrl: ICON_URL,
                    },
                ],
                clickAction: {
                    type: 'link',
                    href: pathfinder(
                        'book_publish_project_page',
                        {
                            id: project.id,
                            service: relevantService,
                        },
                        { query: { source: 'lihp_job_to_be_done_card' } }
                    ),
                },
            };
        } catch (error: any) {
            logger.error(error, { description: 'Failed to fetch data for jbtd_card_book_publishing_project' });

            return {
                shouldDisplayJob: false,
            };
        }
    },
    cardCallbacks: {
        onCardClick: reportCardClick,
    },
} satisfies EagerJobsTbdSdk;
